export const status = [
  {text: 'На рассмотрении', value: 'INIT'},
  {text: 'Принято', value: 'ACCEPTED'},
  {text: 'Отказано', value: 'REJECTED'}
]

export const applicationStatusAsString = function(type) {
  if (type) {
    return status.find(it => it.value === type).text
  } else {
    return '-'
  }
}
